import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  standalone: true,
})
export class SearchPipe implements PipeTransform {
  transform(values: any[], searchValue: string): any[] {
    if (!values) return [];
    if (!searchValue) return values;

    return values.filter((value) => {
      const haystack = [
        value.titreDto,
        value.bienDto?.titreDto,
        value.adresseDto?.villeDto,
        value.adresseDto?.rueDto,
        value.adresseDto?.codePostalDto,
        value.nomDto,
        value.prenomDto,
        value.telephoneDto,
        value.mailDto,
        value.logementDto?.typeUniteDto,
        value.logementDto?.numeroDto,
        value.logementDto?.bienDto?.titreDto,
      ]
        .filter((part) => typeof part === 'string' && part.length > 0)
        .join(' ')
        .toLowerCase();
      return haystack.includes(searchValue.toLowerCase());
    });
  }
}
